// Utils
import cn from '../../../../utils/cn';
import { formatTime } from '../../../../utils/formatDate';
// Styles
import styles from './TimeCell.module.css';
import commonStyles from '../TableCellCommon.module.css';

/**
 * Time cell component for displaying time values in table cells (read-only)
 * @param {object} props
 * @param {string} [props.value] - Time value in HH:mm format
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.placeholder='--:--'] - Placeholder for empty values
 * @param {Align} [props.align='left'] - Text alignment
 * @param {VerticalAlign} [props.verticalAlign='middle'] - Vertical alignment
 * @param {boolean} [props.bold=false] - Text in bold
 * @param {boolean} [props.italic=false] - Text in italic
 * @param {boolean} [props.strikeThrough=false] - Text with strike-through
 * @param {boolean} [props.underline=false] - Text underlined
 * @returns {JSX.Element}
 */
function TimeCell({
  value,
  className = '',
  placeholder = '--:--',
  align = 'center',
  verticalAlign = 'middle',
  bold = false,
  italic = false,
  strikeThrough = false,
  underline = false,
}) {
  const isEmpty = !value || value === '';
  const formattedValue = isEmpty ? placeholder : formatTime(value);

  return (
    <div
      className={cn([
        styles['time-cell'],
        className,
        bold && commonStyles['cell-bold'],
        italic && commonStyles['cell-italic'],
        strikeThrough && commonStyles['cell-strike-through'],
        underline && commonStyles['cell-underline'],
        align && commonStyles[`cell-align-${align}`],
        verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      ])}
    >
      <div
        className={styles['time-cell-input']}
      >
        {formattedValue}
      </div>
    </div>
  );
}

export default TimeCell;
